import { InstagramAppId, NATUrl } from './constants';

export class Instagram {
  public static authorize(): void {
    const redirectUrl = window.location.origin;
    const oauthUrl = encodeURIComponent(`https://www.instagram.com/oauth/authorize?client_id=${InstagramAppId}&response_type=code&scope=user_profile,user_media&redirect_uri=${NATUrl}`);
    try {
      window.location.replace(`${NATUrl}?oauth_url=${oauthUrl}&redirect_url=${redirectUrl}`);
    } catch (e) {
      throw new Error('unable to connect to instagram');
    }
  }
}
